var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallMountedTelephoneDataBox01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.84,14.17H2.72V4.06h10.13V14.17z M3.22,13.67h9.13V4.56H3.22V13.67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.53,
    y: 1.4,
    className: "st2",
    width: 0.5,
    height: 2.91
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5.36,11.08V7.61h-1.3V7.14h3.12v0.46h-1.3v3.47H5.36z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.24,11.08V7.14H9.6c0.31,0,0.54,0.02,0.7,0.06c0.23,0.05,0.42,0.15,0.58,0.28c0.21,0.18,0.36,0.4,0.47,0.67 c0.1,0.27,0.16,0.58,0.16,0.94c0,0.3-0.04,0.56-0.11,0.79c-0.07,0.23-0.16,0.42-0.27,0.57c-0.11,0.15-0.23,0.27-0.36,0.36 s-0.29,0.15-0.47,0.2s-0.39,0.07-0.63,0.07H8.24z M8.76,10.62H9.6c0.26,0,0.46-0.02,0.61-0.07c0.15-0.05,0.26-0.12,0.35-0.2 c0.12-0.12,0.22-0.29,0.29-0.5c0.07-0.21,0.1-0.46,0.1-0.76c0-0.41-0.07-0.73-0.2-0.95c-0.13-0.22-0.3-0.37-0.49-0.44 C10.12,7.64,9.9,7.61,9.59,7.61H8.76V10.62z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallMountedTelephoneDataBox01);
export default __webpack_public_path__ + "static/media/WallMountedTelephone-DataBox-01.2723fde61483e6c57d0ee2c14483131e.svg";
export { ForwardRef as ReactComponent };